declare var appConfig: any;

interface IBaseClass<T> {
    // new (): T;
    assignJSON(json: any): T;
}

class BaseClass<T> implements IBaseClass<T> {
    public assignJSON(json: any): T {
        return Object.assign(this, json);
    }
}

export class ArrayFactory {
    static fromJSON<T extends IBaseClass<T>>(
        type: { new (): T },
        jsonarray: any
    ): Array<T> {
        var ret = new Array<T>();
        if (jsonarray) {
            for (let entry of jsonarray) {
                let c = new type();
                c = c.assignJSON(entry);
                ret.push(c);
            }
        }
        return ret;
    }
}

export class ClassFactory {
    static fromJSON<T extends IBaseClass<T>>(
        type: { new (): T },
        json: any
    ): T {
        let c = new type();
        c = c.assignJSON(json);
        return c;
    }
}

export class Session {
    public ProviderList: any = [];

    constructor() {}
}

export class FilterOptions {
    public FilterString: string;
}

export class ListColumn {
    public Title: string;
    public Name: string;
    public ClassName: string;
    public Filtering: FilterOptions;
}

export class Filter {
    public FieldName: string;
    public SearchTerm: string;

    constructor(fname: string, fvalue: string) {
        this.FieldName = fname;
        this.SearchTerm = fvalue;
    }
}
export class Advertise {
    public ProductID: number;
    public RateFactor = 25;
    constructor(adv: any) {
        Object.assign(this, adv);
    }
}

export class ProviderContext {
    public Paging = true;
    public ItemsPerPage = 25;
    public Page = 1;
    public TotalItems = 0;
    public JumpToFirst = true;
    public ProviderCode: string;
    public KeyField: string;
    public ClassName: string;
    public SortField: string;
    public IsAsc: boolean;
    public SortField2: string;
    public IsAsc2: boolean;
    public FilterList: Array<Filter> = new Array();

    constructor(dtx: any) {
        Object.assign(this, dtx);
    }

    public addFilter(fname: string, fvalue: string) {
        if (fvalue) {
            this.FilterList.push(new Filter(fname, fvalue));
        }
    }

    public updateFilter(fname: string, fvalue: string) {
        let f = this.FilterList.filter((x) => x.FieldName == fname)[0];
        if (f) {
            f.SearchTerm = fvalue;
        } else {
            this.FilterList.push(new Filter(fname, fvalue));
        }
    }

    public clearFilter() {
        this.FilterList = new Array<Filter>();
    }
}

export enum Providers {
    Unknown = 0,
    Tesco = 1,
    Auchan = 2,
    Prima = 3,
    GRoby = 4,
    LacsiBoltja = 5,
    Real = 7,
    Kellys = 9,
    Hellas = 10,
    BrandBank = 100,
}

export class ResourceItemDTO {
    public DayDateFrom: Date;

    public DayDateTo: Date;

    public VehicleTypeID: number = 0;

    public fromH: number;

    public toH: number;

    public Count: number = 1;
}

export class ChatGptTrainingRule {
    public ChatGptTrainingRuleId: number;
    public Role: string;
    public Content: string;
    public Active: boolean;
}

export class ChatGptCheckingStartDTO {
    public ProviderId: number;
    public NumberOfProductProviders: number;
    public OnlyUnhandledProductProviders: boolean = true;
}

export class ChatGptProductSearchDTO {
    public ProductName: string;
    public ProductId: number;
    public OnlyWhenAiData: boolean;
}

export class ChatGptProductSaveDTO {
    public ProductId: number;
    public GeneratedData: string;
}

export class ChatGptProductSearchResultDTO {
    public ProductId: number;
    public ProductName: string;
    public AiGeneratedData: string;
}

export class CrawlerSessionDto {
    public CrawlerSessionId: number;
    public Status: string;
    public StatusText: string;
    public ProviderName: string;
    public Filename: string;
    public ErrorList: string[];
    public NumberOfAllProducts: number;
    public NumberOfNewProducts: number;
    public NumberOfUpdateProducts: number;
    public NumberOfDeactivateProducts: number;
    public Error: string;
    public Created: Date;
    public Closed: Date;
    public ElapsedTime: Date;
    public ChatGptAllProducts: number;
    public ChatGptCurrentProduct: number;
}

export class ArchiePredefinedFunction {
    public ArchiePredefinedFunctionID: string;
    public FunctionName: string;
    public FunctionDescription: string;
    public FunctionInstruction: string;
    public RawSQLQuery: string;
    public Active: boolean;
    public IsExtraLogicRequired: boolean;
    public FunctionTypeID: number;
    public FunctionExtraLogicTypeID: number;
    public FrequencyPenalty: number | undefined;
    public MaxTokens: number | undefined;
    public PresencePenalty: number | undefined;
    public TopP: number | undefined;
    public N: number | undefined;
    public Stream: boolean | undefined;
    public Stop: string | undefined;
    public Model: string | undefined;
    public Temperature: number | undefined;
    public ExtraContentUrl: string | undefined;
    public ArchiePredefinedFunctionParameterList: Array<ArchiePredefinedFunctionParameter>;
    public ArchieTrainingRuleList: Array<ArchieTrainingRule>;
    public ArchiePredefinedFunctionLogs: Array<ArchiePredefinedFunctionLog>;
    public SearchTypeID: number | undefined;
}

export class ArchieTrainingRule {
    public ArchiePredefinedFunctionID: string;
    public Role: string;
    public Content: string;
    public Active: boolean;
}

export class ArchiePredefinedFunctionParameter {
    public ArchiePredefinedFunctionID: string;
    public Name: string;
    public Type: string;
    public Description: string;
}

export class ArchieParameters {
    public FunctionTypes: Array<string>;
    public FunctionExtraLogicTypes: Array<string>;
    public Models: Array<string>;
    public SearchTypes: Array<string>;
}

export class ArchieSavePredefinedFunctionDto {
    public ArchiePredefinedFunction: ArchiePredefinedFunction;
    public Username: string;
    public Description: string;
}

export class ArchiePredefinedFunctionLog {
    public OriginalStateJson: string;
    public UpdatedStateJson: string;
    public Description: string | undefined;
    public UserEmail: string | undefined;
    public Created: Date;
    public Changes: string;
}